'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FONT_FAMILIES = [
/* eslint-disable max-len */
// SERIF
{ key: 'font_family_1', value: 'Georgia, serif', description: 'Georgia', type: 'Serif' }, { key: 'font_family_2', value: '"Palatino Linotype", "Book Antiqua", Palatino, serif', description: 'Palatino', type: 'serif' }, { key: 'font_family_3', value: '"Times New Roman", Times, serif', description: 'Times New Roman', type: 'serif' },

// SANS-SERIF
{ key: 'font_family_4', value: 'Arial, Helvetica, sans-serif', description: 'Arial', type: 'Sans-Serif' }, { key: 'font_family_5', value: '"Arial Black", Gadget, sans-serif', description: 'Arial Black', type: 'Sans-Serif' }, { key: 'font_family_6', value: '"Comic Sans MS", cursive, sans-serif', description: 'Comic Sans MS', type: 'Sans-Serif' }, { key: 'font_family_7', value: 'Impact, Charcoal, sans-serif', description: 'Impact', type: 'Sans-Serif' }, { key: 'font_family_8', value: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', description: 'Lucida Sans Unicode', type: 'Sans-Serif' }, // eslint-disable-line max-len
{ key: 'font_family_9', value: 'Tahoma, Geneva, sans-serif', description: 'Tahoma', type: 'Sans-Serif' }, { key: 'font_family_10', value: '"Trebuchet MS", Helvetica, sans-serif', description: 'Trebuchet MS', type: 'Sans-Serif' }, { key: 'font_family_11', value: 'Verdana, Geneva, sans-serif', description: 'Verdana', type: 'Sans-Serif' },

// MONOSPACE
{ key: 'font_family_12', value: '"Courier New", Courier, monospace', description: 'Courier New', type: 'Monospace' }, { key: 'font_family_13', value: '"Lucida Console", Monaco, monospace', description: 'Lucida Console', type: 'Monospace' }];
var DEFAULT = exports.DEFAULT = FONT_FAMILIES[3];
exports.default = FONT_FAMILIES;


//////////////////
// WEBPACK FOOTER
// ./src/constants/fontFamilies.js
// module id = 660
// module chunks = 0